import httpClient from './httpClient'

const END_POINT = '/api/idiomas'

const getIdiomas = async () => await httpClient.get(END_POINT)

export {

    getIdiomas,

}